import { ProcedureTaxPoint } from 'ts-types/api.types';

export const findLatestTaxPoint = (values: Array<ProcedureTaxPoint>) => {
  return values.length > 0 ? values
      .reduce((prev, current) =>
          (prev.fromDate > current.fromDate) ? prev : current) : null;

};
